export const isReplaceable = (n: number) => (10000 <= n && n < 20000) || n == 0 || n == 3
